var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "IconButtonWrapper",
    _vm._b(
      { staticClass: "move-button" },
      "IconButtonWrapper",
      _vm.$attrs,
      false
    ),
    [
      _c("img", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { src: require("@/assets/buttons/move-button.svg") },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }